import axios from 'axios';
import { isMobile, isTablet } from 'react-device-detect';
import {
  RouteAnalysisResponse,
  FuelStrategyResponse,
  CalculateCyclingFuelStrategyRequest,
  CalculateFuelIntervalsRequest,
  CalculateFuelIntervalsResponse,
  ValidateBonkRiskRequest,
  ValidateBonkRiskResponse,
  GenerateStickerRequest,
  EnergyProfileRequest,
  EnergyProfileResponse,
  BonkCheckResponse,
} from '../models';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? '',
  timeout: 30000,
});

let tokenGetter: (() => Promise<string | null>) | null = null;

export function setTokenGetter(getter: () => Promise<string | null>) {
  tokenGetter = getter;
}

client.interceptors.request.use(async (config) => {
  // Detect platform accurately
  let platform = 'web-desktop';
  if (isTablet) {
    platform = 'web-tablet';
  } else if (isMobile) {
    platform = 'web-mobile';
  }
  config.headers['Platform-Context'] = platform;

  if (tokenGetter) {
    const token = await tokenGetter();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

export async function analyzeRoute(file: File): Promise<RouteAnalysisResponse> {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await client.post<RouteAnalysisResponse>('/api/v1/routes/analyze', formData);
  return data;
}

export async function calculateFuelIntervals(req: CalculateFuelIntervalsRequest): Promise<CalculateFuelIntervalsResponse> {
  const { data } = await client.post<CalculateFuelIntervalsResponse>('/api/v1/fuel-intervals/calculate', req);
  return data;
}

export async function calculateStrategy(req: CalculateCyclingFuelStrategyRequest): Promise<FuelStrategyResponse> {
  const { data } = await client.post<FuelStrategyResponse>('/api/v1/fuel-strategies/calculate', req);
  return data;
}

export async function validateBonkRisk(req: ValidateBonkRiskRequest): Promise<ValidateBonkRiskResponse> {
  const { data } = await client.post<ValidateBonkRiskResponse>('/api/v1/fuel-strategies/validate-bonk', req);
  return data;
}

export async function calculateEnergyProfile(req: EnergyProfileRequest): Promise<EnergyProfileResponse> {
  const { data } = await client.post<EnergyProfileResponse>('/api/v1/fuel-intervals/energy-profile', req);
  return data;
}

export async function checkBonkRisk(req: EnergyProfileRequest): Promise<BonkCheckResponse> {
  const { data } = await client.post<BonkCheckResponse>('/api/v1/fuel-intervals/bonk-check', req);
  return data;
}

export async function generateSticker(req: GenerateStickerRequest): Promise<Blob> {
  const { data } = await client.post('/api/v1/stickers/generate', req, { responseType: 'blob' });
  return data;
}
